import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Utils } from '@app/shared/services/utils.service';
import { wrapError } from '@app/utils/rxjs';
import { Observable } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { DeviceAttributeSpec } from '../interfaces/device-attribute-spec';
import { DeviceAttribute } from '../interfaces/device-attribute-type';

@Injectable({
  providedIn: 'root',
})
export class DeviceAttributeRepository {
  constructor(
    private http: HttpClient,
    private utils: Utils
  ) {}

  create(model: DeviceAttribute): Observable<void> {
    return this.utils.routeBasedApiUrl('/deviceAttributes').pipe(
      mergeMap((url) => this.http.post<void>(url, model)),
      wrapError('device-attribute-repository:create')
    );
  }

  delete(id: number): Observable<void> {
    return this.utils.routeBasedApiUrl(`/deviceAttributes/${id}`).pipe(
      mergeMap((url) => this.http.delete<void>(url)),
      wrapError('device-attribute-repository:delete')
    );
  }

  listDeviceAttributeSpecifications(deviceSpecId: string): Observable<DeviceAttributeSpec[]> {
    return this.utils.routeBasedApiUrl(`/deviceAttributesSpec/${deviceSpecId}`).pipe(
      mergeMap((url) => this.http.get<DeviceAttributeSpec[]>(url)),
      wrapError('device-attribute-repository:getDeviceAttributeSpec')
    );
  }

  list(): Observable<DeviceAttribute[]> {
    return this.utils.routeBasedApiUrl(`/deviceAttributes`).pipe(
      mergeMap((url) => this.http.get<DeviceAttribute[]>(url)),
      wrapError('device-attribute-repository:list')
    );
  }

  update(model: DeviceAttribute, attributeId: number): Observable<void> {
    return this.utils.routeBasedApiUrl(`/deviceAttributes/${attributeId}`).pipe(
      mergeMap((url) => this.http.put<void>(url, model)),
      wrapError('device-attribute-repository:update')
    );
  }
}
